import _ from 'lodash'

import { Select } from 'peach/components'
import { getName } from 'peach/helpers'

import { useCompanyRoleGetAll } from 'core/types'

const CrossCompanyRolesSelect = (props) => {
  const { companyId } = props

  const { data: roles = [], isLoading } = useCompanyRoleGetAll({
    companyId,
    query: { limit: 100 },
  })

  const options = _.map(roles, (role) => {
    const { id } = role
    const name = getName(role)

    return {
      value: id,
      label: name || id,
    }
  })

  return (
    <Select
      {...props}
      disabled={isLoading || !companyId}
      label={props.label || 'Roles'}
      loading={isLoading}
      multi={props.multi !== false}
      options={options}
    />
  )
}

export default CrossCompanyRolesSelect
